import { defineComponent } from '@vue/composition-api';
import { useFormat } from '@ideavivat/vivat-2';

import AvailableVehicleDisplay from '@/components/Driver/AvailableVehicleDisplay.vue';

export default {
  types: {
    _primaryControls: {
      width: '2rem',
    },
    _increment: {
      name: 'ลำดับ',
      width: '4rem',
      class: 'text-center',
    },
    code: {
      name: 'รหัสการจ่ายเงิน',
      width: '8rem',
    },
    'area.code': {
      name: 'Area Code',
      width: '6rem',
    },
    name: {
      name: 'ชื่อรายการ',
      width: '18rem',
    },
    type: {
      name: 'ประเภท',
      width: '8rem',
      class: {
        cell: 'text-left',
        text: 'text-left',
      },
      // eslint-disable-next-line
      filter: (val: string) => val === 'DRIVER' ? 'คนขับรถ' : 'พนักงานยกของ',
    },
    availableVehicleType: {
      name: 'สามารถใช้กับ',
      width: '18rem',
      class: 'text-center',
      component: defineComponent({
        render(createElement: any) {
          return createElement(
            AvailableVehicleDisplay,
            {
              attrs: {
                vehicle: (this as any).row.item.availableVehicleType,
              },
              props: { row: {} },
            },
          );
        },
        props: { row: {} },
      }),
      filter: () => '',
    },
    fee: {
      name: 'ค่าเที่ยว',
      width: '6rem',
      class: 'text-right',
      filter: (val: string) => useFormat.number(val).currency(),
    },
    driverAllowance: {
      name: 'เบี้ยเลี้ยง',
      width: '6rem',
      class: 'text-right',
      filter: (val: string) => useFormat.number(val).currency(),
    },
    fine: {
      name: 'ค่าปรับ',
      width: '6rem',
      class: 'text-right',
      filter: (val: string) => useFormat.number(val).currency(),
    },
    workDays: {
      name: 'จำนวนวัน',
      width: '6rem',
      class: 'text-right',
      filter: (val: string) => `${val} วัน`,
    },
    createdAt: {
      name: 'สร้างเมื่อ',
      width: '12rem',
      class: 'text-center',
      filter: (val: string) => useFormat.date(val).displayShortThaiDateTime(),
    },
    updatedAt: {
      name: 'แก้ไขล่าสุด',
      width: '12rem',
      class: 'text-center',
      filter: (val: string) => useFormat.date(val).displayShortThaiDateTime(),
    },
    // eslint-disable-next-line
    hub_id: {
      name: 'Hub',
      width: '6rem',
      filter: (val: any, row: any) => row.item.hub?.name || '',
    },
    _activeControls: {
      name: 'เปิด/ปิด',
      width: '6rem',
    },
  },
  sortable: [
    'name',
    'vehicleType',
    'availableVehicleType',
    'fuelPrice',
    'tripPrice',
    'allowance',
    'hub_id',
    'createdAt',
    'updatedAt',
  ],
};
